/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {IpRange} from '../models/IpRange';

export interface UpdateAccountIpRanges$Request {
    accountId: number;
    ipRange: Array<IpRange>;
}

export interface UpdateAccountIpRanges$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateAccountIpRangesRequest = createAction<PayloadData<void, UpdateAccountIpRanges$Request>>('UPDATE_ACCOUNT_IP_RANGES__UPDATE_ACCOUNT_IP_RANGES__REQUEST');
export const updateAccountIpRangesSuccess = createAction<PayloadData<void, UpdateAccountIpRanges$Request>>('UPDATE_ACCOUNT_IP_RANGES__UPDATE_ACCOUNT_IP_RANGES__SUCCESS');
export const updateAccountIpRangesFailure = createAction<PayloadData<Error, UpdateAccountIpRanges$Request, true>>('UPDATE_ACCOUNT_IP_RANGES__UPDATE_ACCOUNT_IP_RANGES__FAILURE');

export const updateAccountIpRangesActions = [
    updateAccountIpRangesRequest,
    updateAccountIpRangesSuccess,
    updateAccountIpRangesFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {Array<IpRange>} meta.ipRange
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateAccountIpRanges = (meta: UpdateAccountIpRanges$Request, config?: UpdateAccountIpRanges$Config) => {
    return {
        CALL_API: {
            types: updateAccountIpRangesActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/ip-ranges`,
            TRANSPORT_REQUEST_BODY: meta.ipRange,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

